import React from 'react';
import ErrorContent from './ErrorContent';

const Error500 = ({ message, height }) => (
    <ErrorContent height={height} error={'500'} message={message || 'Internal Server Error'} />
)

export default Error500;
